import React from 'react';
import {
  Button,
  DatePicker,
  // Drawer,
  Table,
  Col,
  Form,
  Select,
  Row,
  Typography,
} from 'antd';
import './growth_checker_report.css';
import reqwest from './apiRequest';
import moment from 'moment';

const { RangePicker } = DatePicker;
const { Title } = Typography;
const { Option } = Select;

class App extends React.Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        title: 'Create Date',
        dataIndex: 'created_time',
        key: 'created_time',
        render: (created_time) => moment(created_time).format('DD/MM/YY HH:mm'),
      },
      {
        title: 'Gender',
        dataIndex: 'child_gender',
        key: 'child_gender',
      },
      {
        title: 'DoB',
        dataIndex: 'child_data_of_birth',
        key: 'child_data_of_birth',
        render: (dob) => moment(dob).format('DD/MM/YY'),
      },
      {
        title: 'Height',
        dataIndex: 'height',
        key: 'height',
        render: (value, item) => this.displayHeightValue(item),
      },
      {
        title: 'Weight',
        dataIndex: 'weight',
        key: 'weight',
        render: (value, item) => this.displayWeightValue(item),
      },
      {
        title: 'Height Result',
        dataIndex: 'height_result',
        key: 'height_result',
        render: (height_result) => (height_result != null) ? height_result.charAt(0).toUpperCase() + height_result.slice(1) + ' Height' : '-',
      },
      {
        title: 'Weight Result',
        dataIndex: 'weight_result',
        key: 'weight_result',
        render: (weight_result) => (weight_result != null) ? weight_result.charAt(0).toUpperCase() + weight_result.slice(1) + ' Weight' : '-',
      },
    ];

    this.state = {
      data: [],
      search: {
        filter_date: null,
        age: null,
        gender: null,
        height_result: null,
        weight_result: null,
      },
      placeholder: ['Start Date', 'End Date'],
      pagination: {},
      loading: false,
      visible: false,
    };
  }

  displayHeightValue = (item) => {
    if (item && item != null) {
      if (item.height_unit === 'cm') {
        return `${item.height_cm} cm`;
      } else if (item.height_unit === 'ft_in') {
        return `${item.height_ft} ft ${item.height_in} in`;
      }
    }
    return '-';
  };

  displayWeightValue = (item) => {
    if (item && item != null) {
      if (item.weight_unit === 'kg') {
        return `${item.weight_kg} kg`;
      } else if (item.weight_unit === 'lb') {
        return `${item.weight_lb} lb`;
      }
    }
    return '-';
  };

  componentDidMount() {
    document.title = 'Growth Checker Report';
    this.fetch();
  }

  fetch = (params = {}) => {
    console.log({
      age: this.state.search.age,
      gender: this.state.search.gender,
      height_result: this.state.search.height_result,
      weight_result: this.state.search.weight_result,
      date_range: this.state.search.filter_date,
      ...params,
    });
    this.props.pageLoading(true);

    reqwest({
      url: process.env.REACT_APP_API_URL + '/growth_checker',
      method: 'get',
      data: {
        age: this.state.search.age,
        gender: this.state.search.gender,
        height_result: this.state.search.height_result,
        weight_result: this.state.search.weight_result,
        date_range: this.state.search.filter_date,
        ...params,
      },
      type: 'json',
    }).then((data) => {
      this.setState({
        data: data.results,
      });

      this.props.pageLoading(false);

      document.body.style.overflow = null;
    });
  };

  filterData = async () => {
    const { search } = this.state;
    const { filter_date, result, age_group } = search;

    const body = {
      age_group_id: age_group || null,
      results: result || null,
      range_date: filter_date || null,
    };

    this.setState({ loading: true });
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/growth_checker`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        },
      );
      const data = await response.json();
      this.setState({
        data: data.results,
        loading: false,
      });
    } catch (error) {
      this.setState({ loading: false });
      console.error('Error fetching data:', error);
    }
  };

  handleFormChange = (changedValues) => {
    const { search } = this.state;

    this.setState(
      {
        search: {
          ...search,
          ...changedValues,
        },
      },
      () => {
        this.fetch();
      },
    );

    // if (changedValues.filter_date) {
    //   const [start, end] = changedValues.filter_date;

    //   this.setState({
    //     placeholder:
    //       start && end
    //         ? [start.format('DD/MM/YYYY'), end.format('DD/MM/YYYY')]
    //         : ['Start Date', 'End Date'],
    //   });
    // }
  };

  handleDateRangeFilterChange = (value) => {
    if (value.length > 0) {
      const [start, end] = value;
      console.log({ start, end });
      var date = [start.format('DD/MM/YYYY'), end.format('DD/MM/YYYY')];
      console.log({ date });
      this.handleFormChange({ filter_date: date });

      this.setState({
        placeholder: [start.format('DD/MM/YYYY'), end.format('DD/MM/YYYY')],
      });
    } else {
      this.handleFormChange({ filter_date: '' });

      this.setState({
        placeholder: ['Start Date', 'End Date'],
      });
    }
  };

  exportExcel = async () => {
    const { search } = this.state;

    const body = {
      age_group_id: search.age_group || null,
      results: search.result || null,
      date_range: search.filter_date || null,
    };

    this.setState({ loading: true });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/growth_checker/export`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        },
      );

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'growth-checker-results.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Failed to download file');
      }

      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.error('Error fetching data:', error);
    }
  };

  resetFilter = () => {
    this.props.form.resetFields();
    this.setState(
      {
        search: {
          filter_date: null,
          age_group: null,
          result: null,
        },
        placeholder: ['Start Date', 'End Date'],
      },
      () => {
        this.fetch();
      },
    );
  };

  render() {
    const {
      // visible, drawer,
      search, placeholder, data, pagination, loading } =
      this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div id="growth-checker-report-component">
        <Row>
          <Col span={24}>
            <Title level={1}>Growth Checker Report</Title>
          </Col>
        </Row>

        <div className="growth-checker-report-container">
          <Row gutter={[16, 16]}>
            <Col span={4}>
              <Form.Item>
                {getFieldDecorator('filter_date', {
                  initialValue: search.filter_date,
                })(
                  <RangePicker
                    format={'DD/MM/YYYY'}
                    placeholder={placeholder}
                    style={{ width: '100%' }}
                    onChange={(dates) =>
                      this.handleDateRangeFilterChange(dates)
                    }
                  />,
                )}
              </Form.Item>
            </Col>

            <Col span={3}>
              <Form.Item>
                {getFieldDecorator('age', {
                  initialValue: search.age,
                })(
                  <Select
                    placeholder="Age"
                    style={{ width: '100%' }}
                    onChange={(value) =>
                      this.handleFormChange({ age: value })
                    }
                  >
                    <Option value={null}>All Age</Option>
                    <Option value="1">1 year</Option>
                    <Option value="2">2 years</Option>
                    <Option value="3">3 years</Option>
                    <Option value="4">4 years</Option>
                    <Option value="5">5 years</Option>
                    <Option value="6">6 years</Option>
                    <Option value="7">7 years</Option>
                    <Option value="8">8 years</Option>
                    <Option value="9">9 years</Option>
                    <Option value="10">10 years</Option>
                  </Select>,
                )}
              </Form.Item>
            </Col>

            <Col span={3}>
              <Form.Item>
                {getFieldDecorator('gender', {
                  initialValue: search.gender,
                })(
                  <Select
                    placeholder="Gender"
                    style={{ width: '100%' }}
                    onChange={(value) =>
                      this.handleFormChange({ gender: value })
                    }
                  >
                    <Option value={null}>All Gender</Option>
                    <Option value="F">F</Option>
                    <Option value="M">M</Option>
                  </Select>,
                )}
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item>
                {getFieldDecorator('height_result', {
                  initialValue: search.height_result,
                })(
                  <Select
                    placeholder="Height Result"
                    style={{ width: '100%' }}
                    onChange={(value) =>
                      this.handleFormChange({ height_result: value })
                    }
                  >
                    <Option value={null}>All Height Result</Option>
                    <Option value="normal">Normal Height</Option>
                    <Option value="over">Over Height</Option>
                    <Option value="under">Under Height</Option>
                  </Select>,
                )}
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item>
                {getFieldDecorator('weight_result', {
                  initialValue: search.weight_result,
                })(
                  <Select
                    placeholder="Weight Result"
                    style={{ width: '100%' }}
                    onChange={(value) =>
                      this.handleFormChange({ weight_result: value })
                    }
                  >
                    <Option value={null}>All Weight Result</Option>
                    <Option value="normal">Normal Weight</Option>
                    <Option value="over">Over Weight</Option>
                    <Option value="under">Under Weight</Option>
                  </Select>,
                )}
              </Form.Item>
            </Col>

            <Col span={3}>
              <Button onClick={this.resetFilter}>Reset</Button>
            </Col>

            <Col span={3}>
              <Button
                type="primary"
                style={{ width: '100%' }}
                onClick={this.exportExcel}
              >
                Export
              </Button>
            </Col>
          </Row>
          <Table
            columns={this.columns}
            dataSource={data}
            pagination={pagination}
            loading={loading}
            onChange={this.handleTableChange}
          />
        </div>
      </div>
    );
  }
}

export default Form.create({ name: 'growth_checker_report_form' })(App);
